import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/carPackage';
import PackagesCarouselSkeleton from '../../others/Skeleton/SkeletonPackagesCarousel';
import FaresCarouselBackgroundImageContainerMobile from '../FaresCarouselBackgroundImageContainerMobile';

const FlightsCarsPackagesCarouselContainerMobile = (props) => (
  <FaresCarouselBackgroundImageContainerMobile
    SkeletonInstance={PackagesCarouselSkeleton}
    {...props}
    getFares={getFares}
  />
);

FlightsCarsPackagesCarouselContainerMobile.componentName =
  'FlightsCarsPackagesCarouselContainerMobile';

FlightsCarsPackagesCarouselContainerMobile.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

FlightsCarsPackagesCarouselContainerMobile.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'flightsCarsPackagesCarouselContainerMobile'
  }
};

export default FlightsCarsPackagesCarouselContainerMobile;
